export const refreshTreeInterval = 5000;
